module.exports = __webpack_public_path__ + "img/balance_1_content.8f573792.webp";